import { APP_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TAppSelector, TEqualityFunction } from '../types';

export const useAppSelector = <TSelected>(selector: TAppSelector<TSelected>, equalityFn?: TEqualityFunction<TSelected>) => {
    return useCustomSelector<TSelected, typeof APP_REDUCER>(APP_REDUCER, selector, equalityFn);
};
